export const SETTINGS_NAV_ITEMS = [
  {
    key: "account",
    label: "Account",
    group: "personal",
    searchTerms: "account profile email name password reset google sign in",
  },
  {
    key: "terminology",
    label: "Terminology",
    group: "organisational",
    searchTerms: "terminology terms customer customers company companies language naming",
  },
  {
    key: "branches",
    label: "Branches and staff",
    group: "organisational",
    searchTerms: "branches staff outlet outlets location locations address team",
  },
  {
    key: "connectors",
    label: "Connectors",
    group: "organisational",
    searchTerms: "connectors connections integrations channels whatsapp telegram instagram messenger line forms tally business data bookings",
  },
  {
    key: "notifications",
    label: "Notifications",
    group: "organisational",
    searchTerms: "notifications notify reminders reminder emails alerts approvals approval queue turn off unsubscribe",
  },
  {
    key: "billing",
    label: "Billing and plan",
    group: "organisational",
    searchTerms: "billing plan subscription payment invoice upgrade downgrade pricing usage",
  },
  {
    key: "support-access",
    label: "Support access",
    group: "support",
    searchTerms: "support access dibs specialist collaborator approval revoke cancel request",
  },
] as const;

export type SettingsPanel = (typeof SETTINGS_NAV_ITEMS)[number]["key"];

export const SETTINGS_NAV_GROUPS = [
  { key: "personal", label: "Personal" },
  { key: "organisational", label: "Organisational" },
  { key: "support", label: "Support" },
] as const;

export const resolveSettingsPanel = (value: string | null): SettingsPanel =>
  SETTINGS_NAV_ITEMS.some((item) => item.key === value)
    ? value as SettingsPanel
    : "account";

export const getSettingsPanelLabel = (value: string | null) => {
  const panel = resolveSettingsPanel(value);
  return SETTINGS_NAV_ITEMS.find((item) => item.key === panel)?.label ?? "Account";
};

export const filterSettingsNavItems = (query: string) => {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  if (!normalizedQuery) return SETTINGS_NAV_ITEMS;

  const queryTerms = normalizedQuery.split(/\s+/);

  return SETTINGS_NAV_ITEMS.filter((item) => {
    const searchableText = `${item.label} ${item.searchTerms}`.toLocaleLowerCase();
    return queryTerms.every((term) => searchableText.includes(term));
  });
};
